export default __webpack_public_path__ + "static/media/lns-logo-primary-color.5aea5f23.png";